import { NavigateFunction } from "react-router-dom";
import apiFetch from "@/app/auth/apiFetch";

const API_URL = import.meta.env.VITE_API_URL;

export interface StoreVersionInfo {
  store: string; // "chrome" | "edge"
  label: string;
  store_url: string | null;
  extension_id: string | null;
  /** True when the authenticated (review-state) credentials are configured. */
  configured: boolean;
  published_version: string | null;
  /** "published" | "unknown" */
  published_state: string;
  review_in_progress: boolean | null;
  review_version: string | null;
  /** "in_review" | "none" | "no_data" | "unknown" | "error" */
  review_state: string;
  /** ISO-8601 — date du dernier événement de publication capturé. */
  submitted_at: string | null;
  /** Statut renvoyé par le store au dernier publish (PENDING_REVIEW, Published…). */
  last_publish_status: string | null;
  errors: string[];
  raw: Record<string, unknown>;
}

export interface StoreVersionsResponse {
  stores: StoreVersionInfo[];
  checked_at: string; // ISO-8601 UTC
}

export async function getPluginStoreVersions(
  navigate: NavigateFunction
): Promise<StoreVersionsResponse> {
  const res = await apiFetch(
    `${API_URL}/admin/plugin-store-versions`,
    { method: "GET" },
    navigate
  );
  if (!res?.ok) {
    throw new Error(
      `Erreur ${res?.status ?? "?"} lors du chargement des versions stores`
    );
  }
  return res.json();
}
